import React from "react";
import { useTheme } from "@mui/material";
import DSDialog from "../system-design/DSDialog";
import DSDialogTitle from "../system-design/DSDialogTitle";
import DSDialogContent from "../system-design/DSDialogContent";
import DSDialogActions from "../system-design/DSDialogActions";
import DSTypography from "../system-design/Typography/DSTypography";
import DSBox from "../system-design/DSBox";
import DSCheckbox from "../system-design/DSCheckBox";
import DSPrimaryButton from "../system-design/DSPrimaryButtom";
import DSSecondaryButton from "../system-design/DSSecondaryButton";

type FinalConfirmationDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onOpenTerms: () => void;
  termsAccepted: boolean;
  onTermsAcceptedChange: (accepted: boolean) => void;
  showTermsError: boolean;
  loading?: boolean;
};

const FinalConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  onOpenTerms,
  termsAccepted,
  onTermsAcceptedChange,
  showTermsError,
  loading = false,
}: FinalConfirmationDialogProps) => {
  const { palette } = useTheme();

  const handleTermsCheckboxChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    onTermsAcceptedChange(event.target.checked);
  };

  return (
    <DSDialog open={open} onClose={onClose}>
      <DSDialogTitle>Final Confirmation</DSDialogTitle>
      <DSDialogContent>
        <DSTypography sx={{ marginBottom: 2 }}>
          Clicking Done will finalize all changes. You won't be able to make
          further edits after confirming. Are you sure you want to continue?
        </DSTypography>

        <DSBox sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <DSCheckbox
            checked={termsAccepted}
            onChange={handleTermsCheckboxChange}
            sx={{ padding: 0 }}
          />
          <DSTypography fontSize={13}>I agree to the</DSTypography>
          <DSTypography
            onClick={onOpenTerms}
            sx={{
              fontSize: 13,
              cursor: "pointer",
              "&:hover": {
                textDecoration: "underline",
              },
            }}
          >
            Terms and Conditions
          </DSTypography>
        </DSBox>

        <DSTypography
          sx={{
            fontSize: 13,
            color: palette.error.main,
            marginLeft: 4,
            visibility: showTermsError ? "visible" : "hidden",
            height: "1.2em",
          }}
        >
          {showTermsError
            ? "Please accept the terms and conditions to continue"
            : " "}
        </DSTypography>
      </DSDialogContent>
      <DSDialogActions>
        <DSSecondaryButton
          sx={{ fontSize: "15px" }}
          onClick={onClose}
          disabled={loading}
        >
          Cancel
        </DSSecondaryButton>
        <DSPrimaryButton
          sx={{ fontSize: "15px" }}
          onClick={onConfirm}
          disabled={loading}
        >
          Done
        </DSPrimaryButton>
      </DSDialogActions>
    </DSDialog>
  );
};

export default FinalConfirmationDialog;
